

  document.addEventListener("DOMContentLoaded", () => {


    /* ==========================================================
      ELEMENTS
    ========================================================== */

    const header = document.getElementById("mauli-header");

  const body = document.body;

  /* Search */

  const searchDrawer = document.querySelector("[data-mauli-search]");

  const searchOpenButtons = document.querySelectorAll("[data-mauli-search-open]");

  const searchCloseButtons = document.querySelectorAll("[data-mauli-search-close]");

  /* Mobile */

  const mobileMenu = document.querySelector("[data-mauli-mobile]");

  const mobileOpenButtons = document.querySelectorAll("[data-mauli-mobile-open]");

  const mobileCloseButtons = document.querySelectorAll("[data-mauli-mobile-close]");


    /* ==========================================================
      SEARCH DRAWER
    ========================================================== */

    function openSearch() {

      if (!searchDrawer) return;

      searchDrawer.classList.add("is-open");

      body.classList.add("search-open");
      body.style.overflow = "hidden";

    }


    function closeSearch() {

      if (!searchDrawer) return;

      searchDrawer.classList.remove("is-open");

      body.classList.remove("search-open");
      if (!body.classList.contains("mobile-menu-open")) {
    body.style.overflow = "";
  }

    }



    searchOpenButtons.forEach(button => {

      button.addEventListener("click", openSearch);

    });


    searchCloseButtons.forEach(button => {

      button.addEventListener("click", closeSearch);

    });



    /* ==========================================================
      MOBILE MENU
    ========================================================== */

    function openMobileMenu() {

    if (!mobileMenu) return;

    mobileMenu.classList.add("is-open");


    body.classList.add("mobile-menu-open");

    body.style.overflow = "hidden";

  }



    function closeMobileMenu() {

    if (!mobileMenu) return;

    mobileMenu.classList.remove("is-open");

    body.classList.remove("mobile-menu-open");
    if (!body.classList.contains("search-open")) {
    body.style.overflow = "";
  }

    resetMobileNavigation();

  }


    mobileOpenButtons.forEach(button => {

      button.addEventListener("click", openMobileMenu);

    });



    mobileCloseButtons.forEach(button => {

      button.addEventListener("click", closeMobileMenu);

    });



    /* ==========================================================
      ESC KEY
    ========================================================== */

    document.addEventListener("keydown", (event) => {

      if (event.key !== "Escape") return;

      closeSearch();

      closeMobileMenu();

    });

    /* ==========================================================
      MOBILE SLIDING NAVIGATION
    ========================================================== */

    const mobileBody = document.querySelector(".mauli-mobile-body");

    const mobilePanels = document.querySelectorAll("[data-mobile-level]");

    const mobileParentButtons = document.querySelectorAll("[data-mobile-target]");

    const mobileBackButtons = document.querySelectorAll("[data-mobile-back]");

    function resetMobilePanels() {

      mobilePanels.forEach(panel => {

        panel.classList.remove("is-active");

      });

    }


    mobileParentButtons.forEach(button => {

      button.addEventListener("click", () => {

        const target = button.dataset.mobileTarget;

        const panel = document.querySelector(
          `[data-mobile-level="${target}"]`
        );

        if (!panel) return;
  resetMobilePanels();
        panel.classList.add("is-active");

  if (mobileBody) {
    mobileBody.classList.add("is-sliding");
  }

      });

    });



    mobileBackButtons.forEach(button => {

      button.addEventListener("click", () => {

        const panel = button.closest(".mauli-mobile-level");

        if (!panel) return;

        panel.classList.remove("is-active");
        button.blur();

        const activePanels = document.querySelectorAll(
          ".mauli-mobile-level.is-active"
        );

        if (activePanels.length === 0) {

        if (mobileBody) {
    mobileBody.classList.remove("is-sliding");
  }

        }

      });

    });



    /* ==========================================================
      RESET MENU WHEN CLOSED
    ========================================================== */

   function resetMobileNavigation() {

  resetMobilePanels();

  if (mobileBody) {
    mobileBody.classList.remove("is-sliding");
  }

}


    
      /* ==========================================================
      STICKY HEADER
    ========================================================== */

    let lastScroll = 0;

    function updateHeader() {

      if (!header) return;

      const currentScroll = window.scrollY;

      if (currentScroll > 50) {

        header.classList.add("is-sticky");

      } else {

        header.classList.remove("is-sticky");

      }
  const scrollDifference = currentScroll - lastScroll;

  if (scrollDifference > 10 && currentScroll > 150) {

    header.classList.add("is-hidden");

  } else if (scrollDifference < -10 || currentScroll <= 150) {

    header.classList.remove("is-hidden");

  }    lastScroll = currentScroll;

    }

    window.addEventListener("scroll", updateHeader);



    /* ==========================================================
      CLOSE DRAWERS ON RESIZE
    ========================================================== */

    window.addEventListener("resize", () => {

      if (window.innerWidth >= 990) {

        closeMobileMenu();

      }

    });

/* ==========================================================
   DESKTOP MEGA MENU
========================================================== */

const megaMenu = document.querySelector("[data-mauli-mega]");
const desktopTriggers = document.querySelectorAll("[data-menu-trigger]");
const megaPanels = document.querySelectorAll(".mauli-mega__panel");
const desktopLinks = document.querySelectorAll(".mauli-navigation__link");

function closeMegaMenu() {

  if (!megaMenu) return;

  megaMenu.classList.remove("is-open");

  megaPanels.forEach(panel => {
    panel.classList.remove("is-active");
  });

}

desktopLinks.forEach(link => {

  link.addEventListener("mouseenter", () => {

    const target = link.dataset.menuTrigger;

    // No dropdown for this menu item
    if (!target) {
      closeMegaMenu();
      return;
    }

    megaPanels.forEach(panel => {
      panel.classList.remove("is-active");
    });

    const panel = document.querySelector(
      '.mauli-mega__panel[data-menu="' + target + '"]'
    );

    if (!panel) {
      closeMegaMenu();
      return;
    }

    megaMenu.classList.add("is-open");
    panel.classList.add("is-active");

  });

});

if (megaMenu) {

  megaMenu.addEventListener("mouseenter", () => {

    megaMenu.classList.add("is-open");

  });

  megaMenu.addEventListener("mouseleave", () => {

    closeMegaMenu();

  });

}

if (header) {

  header.addEventListener("mouseleave", () => {

    closeMegaMenu();

  });

}

    /* ==========================================================
      FOCUS SEARCH INPUT
    ========================================================== */

    const searchInput = document.querySelector(".mauli-search-input");

    searchOpenButtons.forEach(button => {

      button.addEventListener("click", () => {

        if (!searchInput) return;

  requestAnimationFrame(() => {

    requestAnimationFrame(() => {

      searchInput.focus();

    });

  });

      });

    });


    

    /* ==========================================================
      INITIALIZE
    ========================================================== */

    updateHeader();

  });